module.exports = __webpack_public_path__ + "img/duration-image.12c2d057.png";